module.exports = __webpack_public_path__ + "img/nav_bg_2.882a7b2.png";